import { computed, get } from '@ember/object';

export default function jsonStringify(dependentKey) {
  return computed(dependentKey, function () {
    return JSON.stringify(get(this, dependentKey), null, 2);
  });
}
